import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import { PATH_RESEARCH } from '../../routes/paths';

const researchSidebarConfig = [
  {
    subheader: 'menu.research',
    items: [
      {
        title: 'menu.overview',
        path: PATH_RESEARCH.overview,
        icon: <GridViewOutlinedIcon sx={{ width: '100%', height: '100%' }} />
      }
    ]
  }
];

export default researchSidebarConfig;
